import Vue from 'vue';
import { Plugin } from '@nuxt/types';
import { AsarenAPIClient, AsarenAPIClientConfig } from './api';

const asarenApiPlugin: Plugin = (ctx, inject) => {
  // configurations
  const config: AsarenAPIClientConfig = {
    apiUrl: ctx.$config.API_URL || 'https://api.asaren.ai/graphql',
    subscriptionUrl:
      ctx.$config.SUBSCRIPTION_URL || 'wss://api.asaren.ai/subscriptions',
    cryptoGraphqlKey:
      ctx.$config.CRYPTO_GRAPHQL_KEY || 'f0e4017ba53f492ed6a55c7e859e4a33',
    cryptoGraphqlSecret:
      ctx.$config.CRYPTO_GRAPHQL_SECRET || '4321567832123456',
    cryptoGraphqlAlgorithm:
      ctx.$config.CRYPTO_GRAPHQL_ALGORITHM ||
      'AES-GCM'
  };
  // configure clients
  const apiClient = new AsarenAPIClient(config, ctx);
  const client = apiClient.createApolloClient();
  // inject api client
  ctx.$api = client;
  ctx.app.$api = client;
  Vue.prototype.$api = client;

  // inject into vue hooks
  inject('$api', client);
};

export default asarenApiPlugin;
